import { CIcon } from '~/icons/types'
export const ciScooter: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M21.417 16.322 20.071 4.376l2.045-.632a.672.672 0 0 0-.397-1.284l-4.786 1.48a.673.673 0 0 0 .397 1.284l1.433-.443.89 7.894-.006.005-4.635 5.593h-9.2a2.704 2.704 0 1 0 0 1.345h9.516a.674.674 0 0 0 .518-.243l4.015-4.846.206 1.826a2.693 2.693 0 1 0 1.35-.033ZM3.203 20.305a1.359 1.359 0 1 1 0-2.717 1.359 1.359 0 0 1 0 2.717Zm17.593 0a1.359 1.359 0 1 1 .001-2.717 1.359 1.359 0 0 1-.001 2.717Z'
    }
  ],
  name: 'scooter',
  type: 'thin'
}
